var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0714 17.8534C15.0152 20.8158 10.4898 21.4558 6.78642 19.7959C6.23971 19.5825 5.79148 19.4101 5.36537 19.4101C4.17849 19.4169 2.70117 20.5323 1.93336 19.789C1.16555 19.0448 2.31726 17.6118 2.31726 16.4544C2.31726 16.0414 2.14642 15.6147 1.92632 15.0838C0.212831 11.4949 0.874109 7.10724 3.93026 4.14575C7.8316 0.363036 14.17 0.363036 18.0714 4.14478C21.9797 7.93334 21.9727 14.0716 18.0714 17.8534Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9398 11.4006H14.9488",
    stroke: "#130F26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9301 11.4006H10.9391",
    stroke: "#130F26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92128 11.4006H6.93028",
    stroke: "#130F26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.33def0203d7daef2130620cdd0dc3f30.svg";
export { ForwardRef as ReactComponent };